import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";
import { util } from '@citation-js/core';
import parseDoiJson from './json.js';
var apiOptions = {
  checkContentType: true,
  headers: {
    Accept: 'application/vnd.citationstyles.csl+json'
  }
};

function fetchDoiApiAsync(_x) {
  return _fetchDoiApiAsync.apply(this, arguments);
}

function _fetchDoiApiAsync() {
  _fetchDoiApiAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return util.fetchFileAsync(url, apiOptions);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result === '[]' ? {} : JSON.parse(result));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchDoiApiAsync.apply(this, arguments);
}

function parseDoiApiAsync(_x2) {
  return _parseDoiApiAsync.apply(this, arguments);
}

function _parseDoiApiAsync() {
  _parseDoiApiAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
    var doiJsonList;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Promise.all([].concat(data).map(fetchDoiApiAsync));

          case 2:
            doiJsonList = _context2.sent;
            return _context2.abrupt("return", doiJsonList.map(parseDoiJson));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _parseDoiApiAsync.apply(this, arguments);
}

function fetchDoiApi(url) {
  var result = util.fetchFile(url, apiOptions);
  return result === '[]' ? {} : JSON.parse(result);
}

function parseDoiApi(data) {
  return [].concat(data).map(fetchDoiApi).map(parseDoiJson);
}

export { parseDoiApi as parse, parseDoiApiAsync as parseAsync };